import type { ReactNode } from 'react'

import { cn } from '@gto/ui/cn'
import { Typography } from '@gto/ui/typography'

import { InlineHighlightedText } from '../inline-highlighted-text'
import type { ModalCardStyle } from './modal-block-types'

type ModalCardBlockProps = {
  heading: ReactNode
  text: ReactNode
  style?: ModalCardStyle
}

export const ModalCardBlock = ({ heading, text, style = 'default' }: ModalCardBlockProps) => (
  <div
    data-tst="announcement-modal-card"
    className={cn(
      'flex h-full flex-col items-center gap-2 rounded-sm border px-6 py-8 text-center sm:py-6',
      // The accent tint is the primary hover state: the one primary-at-low-alpha
      // surface the tokens define, and close enough to the design's 6% to share it.
      style === 'accent' ? 'border-primary-main/25 bg-primary-states-hover' : 'border-divider',
    )}
  >
    <Typography
      className="max-w-full whitespace-pre-line [overflow-wrap:anywhere]"
      variant="h6"
    >
      {heading}
    </Typography>
    {/* An empty paragraph would still take the `gap-2`, so a heading-only card
        would sit off-centre in its own border. */}
    {text != null && text !== '' ? (
      <Typography
        className="max-w-full whitespace-pre-line [overflow-wrap:anywhere]"
        color="text.secondary"
        variant="body1"
      >
        {typeof text === 'string' ? <InlineHighlightedText text={text} /> : text}
      </Typography>
    ) : null}
  </div>
)
